var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.7 19.7",
    style: {
      enableBackground: "new 0 0 19.7 19.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.7,5.5c-1.7,0-2.5,1-2.5,1.7c0,0.5,0.4,0.6,0.7,0.6c0.2,0,0.3-0.1,0.5-0.3c0.2-0.3,0.5-0.7,1.4-0.7 c0.8,0,1.4,0.4,1.4,1.1c0,0.7-0.6,1.1-1,1.4C10,9.3,9.9,9.4,9.8,9.5c-0.4,0.4-0.9,0.9-0.9,2c0,0.7,0.1,0.8,0.6,0.8 c0.7,0,0.7-0.3,0.7-0.4c0-0.8,0-1.2,0.8-1.8c1-0.8,1.5-1.6,1.5-2.4C12.5,6.3,11.3,5.5,9.7,5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.2,4.6c-0.8-1.2-1.8-2.2-3-3C13.6,0.5,11.7,0,9.9,0C5.2,0,1.1,3.3,0.2,7.9C0.1,8.5,0,9.2,0,9.9 c0,1.9,0.5,3.7,1.5,5.3c0.8,1.2,1.8,2.2,3,3c1.6,1,3.4,1.5,5.3,1.5c4.6,0,8.6-3.1,9.6-7.6c0.2-0.7,0.3-1.5,0.3-2.2 C19.7,8,19.2,6.1,18.2,4.6z M9.9,18.4c-4.7,0-8.6-3.9-8.6-8.6c0-4.7,3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6C18.4,14.6,14.6,18.4,9.9,18.4 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.5,13.4c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9S10,13.4,9.5,13.4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.51f7d347.svg";
export { ForwardRef as ReactComponent };